/**
 * Device-pixel-ratio helpers. Retina tablets multiplied by heavy raymarch
 * shaders are the main perf trap, so we cap the ratio we ever ask for.
 */
export const MAX_DPR = 2;

export function effectiveDpr(): number {
  return Math.min(window.devicePixelRatio || 1, MAX_DPR);
}
